import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import { push as PushMenu, slide as SlideMenu } from "react-burger-menu";
import { Row, Col, Navbar, Nav, NavDropdown, MenuItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { IoClose } from "react-icons/io5";

import * as userActions from "../../actions/userActions";

import MainMenu from "./menus/MainMenu";
import ContractMenu from "./menus/ContractMenu";
import CustomerMenu from "./menus/CustomerMenu";

import CallMenu from "./menus/CallMenu";
import ProjectMenu from "./menus/ProjectMenu";
import SettingsMenu from "./menus/SettingsMenu";

import Avatar from "../styled/Avatar";
import SidebarLogo from "./SidebarLogo";

class Sidebar extends Component {
  getSidebar = () => {
    const { auth, location, history, isMobile } = this.props;

    const { pathname } = location;
    const parsedState = pathname.split("/");

    const menuProps = {
      auth,
      location,
      isMobile,
      history,
      onClickMenu: () => {
        if (isMobile) {
          this.handleStateChange({ isOpen: false });
        }
      }
    };

    if (parsedState.length > 3 && parsedState[3].toString() !== "add") {
      const currentState = parsedState[2].toString();
      switch (currentState) {
        case "contracts":
          return <ContractMenu {...menuProps} />;
        case "customers":
          return <CustomerMenu {...menuProps} />;
        case "calls":
          return <CallMenu {...menuProps} />;
        case "projects":
          return <ProjectMenu {...menuProps} />;
        case "settings":
          return auth?.maxRole === 9000 ? (
            <SettingsMenu {...menuProps} />
          ) : (
            <MainMenu {...menuProps} />
          );
        default:
          return <MainMenu {...menuProps} />;
      }
    } else {
      return <MainMenu {...menuProps} />;
    }
  };

  logOut = () => {
    this.props.actions.logoutUser(this.props.auth.user);
    this.props.history.push("/");
  };

  handleStateChange = (state) => {
    this.props.open(state.isOpen);
  };

  handleAvatarClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.history.push("/app/dashboard");
  };

  // We need this to prevent auto-focus of sidebar
  componentDidMount = () => {
    const [element] = document.getElementsByClassName("bm-item");
    if (element) {
      element.classList.remove("bm-item");
    }
  };

  render() {
    const { auth, modal, isMobile, isOpen } = this.props;

    const dropdown = (
      <Nav>
        <SidebarLogo
          isNightMode={auth.isNightMode}
          onClick={this.handleAvatarClick}
        />
        <NavDropdown
          id="dropdown"
          title={
            <Row>
              <Col
                md={3}
                style={{ paddingRight: 0 }}
                onClick={this.handleAvatarClick}
              >
                <Avatar user={auth.user} avatar={auth.user.avatar} size="sm" />
              </Col>
              <UserHandle user={auth.user} />
            </Row>
          }
        >
          <LinkContainer to="/app/profile">
            <MenuItem
              onClick={() => {
                if (isMobile) {
                  this.handleStateChange({ isOpen: false });
                }
              }}
            >
              Edit Profile
            </MenuItem>
          </LinkContainer>
          {auth.maxRole === 9000 && (
            <LinkContainer to="/app/settings/users">
              <MenuItem
                onClick={() => {
                  if (isMobile) {
                    this.handleStateChange({ isOpen: false });
                  }
                }}
              >
                System Settings
              </MenuItem>
            </LinkContainer>
          )}
          <MenuItem href="#" onClick={this.logOut}>
            Log Out
          </MenuItem>
        </NavDropdown>
      </Nav>
    );

    return (
      <Navbar fixedTop style={{ zIndex: modal.show ? 0 : 1 }}>
        <Menu
          isMobile={isMobile}
          open={isOpen}
          handleStateChange={this.handleStateChange}
        >
          <Navbar.Header>
            <Navbar.Brand>{dropdown}</Navbar.Brand>
          </Navbar.Header>
          {this.getSidebar()}
        </Menu>
      </Navbar>
    );
  }
}

const UserHandle = ({ user }) => (
  <Col md={9} className="user-container">
    <p>{user.full_name}</p>
    <p>{user.email}</p>
  </Col>
);

UserHandle.propTypes = {
  user: PropTypes.object
};

const Menu = ({ children, isMobile, open, handleStateChange }) =>
  isMobile ? (
    <SlideMenu
      pageWrapId="page-wrap"
      outerContainerId="outer-container"
      isOpen={open}
      onStateChange={handleStateChange}
    >
      {children}
    </SlideMenu>
  ) : (
    <PushMenu
      disableCloseOnEsc
      pageWrapId="page-wrap"
      outerContainerId="outer-container"
      isOpen={open}
      noOverlay
      customCrossIcon={<IoClose />}
      onStateChange={handleStateChange}
    >
      {children}
    </PushMenu>
  );

Menu.propTypes = {
  children: PropTypes.node,
  isMobile: PropTypes.bool,
  open: PropTypes.bool,
  handleStateChange: PropTypes.func
};

Sidebar.propTypes = {
  state: PropTypes.object,
  modal: PropTypes.object,
  actions: PropTypes.object.isRequired,
  auth: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
  isMobile: PropTypes.bool,
  open: PropTypes.func,
  isOpen: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state,
    auth: state.reducers.auth,
    modal: state.reducers.modal
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...userActions }, dispatch)
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(Sidebar)
);
